import { Link } from "react-router-dom";
import { useTranslate } from "../../../language/i18n";
import page from "../../../utils/pages";
import Menu from "./Menu/Menu";
import MyPage from "./MyPage/MyPageHeader";
import styles from "./Header.module.scss";
import logo from "../../../assets/logos/Myloc-logga.svg";
import { useAppSelector } from "../../../app/hooks";
import { selectSessionId } from "../../../features/session/sessionSelectors";
import Image from "../../shared/Image/Image";

function Header() {
  const userLoggedIn = !!useAppSelector(selectSessionId);
  const translate = useTranslate();

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.hidden}>{translate("SITE_TITLE")}</h1>
        <div className={styles.logoContainer}>
          <Image src={logo} alt="Myloc - Logo" customCssClass={styles.imageContainer} />
          <Link to={page.HOME}>
            <span>{translate("HEADER_TITLE")}</span>
          </Link>
        </div>
        {userLoggedIn && (
          <div className={styles.rightMenu}>
            <MyPage />
          </div>
        )}
      </div>
      <Menu />
    </header>
  );
}

export default Header;
